import Step from 'shepherd.js/src/types/step';
import {TourSteps} from './interface/tour-steps.interface';

export const registerPatientStep: (tourSteps: TourSteps) => Step.StepOptions[] =
  ({steps, buttons}: TourSteps): Step.StepOptions[] => {
    return [
      {
        ...steps.default,
        id: 'registerPatientStep1',
        title: 'Agregar paciente',
        text: `Da clic en el botón para mostrar las opciones que existen para agregar a un paciente a la clínica.`,
        attachTo: {
          element: '.btn-show-modal-patient',
          on: 'bottom'
        },
        advanceOn: {
          selector: '.btn-show-modal-patient',
          event: 'click'
        },
        buttons: [{...buttons.cancel}],
      },
      {
        ...steps.default,
        id: 'registerPatientStep2',
        title: '¿Cómo deseas agregar al paciente?',
        text: `Hay 2 formas de agregar a un paciente a la clínica: registro manual o mandar un correo de invitación. No te preocupes si no tienes los datos ahora, durante este tour se registrará un paciente DEMO solo para fines demostrativos. Da clic en la opción para continuar.`,
        attachTo: {
          element: '.type-register-1',
          on: 'bottom'
        },
        advanceOn: {
          selector: '.type-register-1',
          event: 'click'
        },
        buttons: [{...buttons.cancel}],
      },
      {
        ...steps.default,
        id: 'registerPatientStep3',
        title: 'Información de tu paciente',
        text: `En este apartado debes completar el formulario con los datos de tu paciente. Para fines del tour no es necesario que ingreses datos durante este paso. Da clic en el botón para continuar.`,
        attachTo: {
          element: '.basic-form-register',
          on: 'top'
        },
        canClickTarget: false,
        classes: undefined,
      },
    ];
  };
